import { useRouter } from "next/router";
import { ProgressSteps } from "@aof/aofgql/progressSteps";
import { useTranslation } from "../../../next-i18next";
import { useEnsureAuth0IdOnUser } from "../../../utils/hooks/useEnsureAuth0IdOnUser";
import { Routes } from "../../../utils/types/routes";
var auth0QueryParams = [
    "code",
    "message",
    "success",
    "supportForgotPassword",
    "verified_email",
];
export var Redirect = function (_a) {
    var progressToSendDown = _a.progressToSendDown;
    var t = useTranslation().t;
    var router = useRouter();
    // Cleanup Auth0 redirection query parameters.
    auth0QueryParams.map(function (qp) {
        delete router.query[qp];
    });
    var pushWithQuery = function (path) {
        router.push({
            pathname: path,
            query: router.query,
        });
    };
    useEnsureAuth0IdOnUser();
    var newFlowSwitch = function (currentStep) {
        switch (currentStep) {
            case ProgressSteps.StartLoan:
                pushWithQuery(Routes.BusinessInformation);
                break;
            case ProgressSteps.BusinessInformation:
                pushWithQuery(Routes.PersonalInformation);
                break;
            case ProgressSteps.PersonalInformation:
                pushWithQuery(Routes.MyFinances);
                break;
            case ProgressSteps.MyFinances:
                pushWithQuery(Routes.ReviewMyApplication);
                break;
            case ProgressSteps.ConnectBankAccount:
                pushWithQuery(Routes.ConnectBankAccount);
                break;
            case ProgressSteps.SubmittedLoanApplication:
                pushWithQuery(Routes.CheckingApplication);
                break;
            case ProgressSteps.GenericError:
                pushWithQuery(Routes.GenericError);
                break;
            case ProgressSteps.Approved:
                pushWithQuery(Routes.PrequalifiedOffers);
                break;
            case ProgressSteps.ApprovedPartner:
                pushWithQuery(Routes.QualifyPartner);
                break;
            case ProgressSteps.Rejected:
                pushWithQuery(Routes.Rejected);
                break;
            case ProgressSteps.SelectedLoanOffer:
                pushWithQuery(Routes.UploadDocuments);
                break;
            case ProgressSteps.UploadDocuments:
                pushWithQuery(Routes.ExistingLoans);
                break;
            case ProgressSteps.ExistingLoans:
            case ProgressSteps.AdditionalDocumentsSubmitted:
            case ProgressSteps.BeneficialOwnersCompleted:
                pushWithQuery(Routes.WeAreReviewing);
                break;
            case ProgressSteps.ExistingLoansCompletedBeneficialOwnerInfoNeeded:
                pushWithQuery(Routes.BeneficialOwners);
                break;
            case ProgressSteps.AdditionalDocumentsRequired:
                pushWithQuery(Routes.WeRequiereAdditionalInfo);
                break;
            case ProgressSteps.DocumentsReviewed:
                pushWithQuery(Routes.SelectAFinalLoanOffer);
                break;
            case ProgressSteps.SelectedFinalLoanOffer:
                pushWithQuery(Routes.OneLastThing);
                break;
            case ProgressSteps.DemographicInformation:
                pushWithQuery(Routes.DocumentSigning);
                break;
            case ProgressSteps.ReviewRequired:
            case ProgressSteps.ReviewRequiredUploadDocumentsBack:
                pushWithQuery(Routes.ReviewRequired);
                break;
            case ProgressSteps.ReviewRequiredUploadDocuments:
                pushWithQuery(Routes.ReviewRequiredUploadDocuments);
                break;
            case ProgressSteps.NoHitError:
            case ProgressSteps.AfterRejected:
            case ProgressSteps.ApplicationError:
            case ProgressSteps.DocumentSigned:
            case ProgressSteps.PrequalifiedError:
                pushWithQuery(Routes.MyAccount);
                break;
            default:
                console.error("ProgressStep", currentStep, "was not routed");
                break;
        }
    };
    if (router.query.email !== undefined &&
        router.query.sfApplicationId !== undefined &&
        router.pathname !== Routes.ClaimLanding &&
        router.pathname !== Routes.SignUpVerifyAccount) {
        pushWithQuery(Routes.ClaimLanding);
    }
    else {
        newFlowSwitch(progressToSendDown);
    }
    return <div>{t("Redirecting")}</div>;
};
//# sourceMappingURL=data:application/json;base64,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